import { Component, forwardRef, Input } from '@angular/core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { DateInputFormControl } from './date-input-form-control';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-date-input-form-control',
  templateUrl: './date-input-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateInputFormControlComponent),
      multi: true
    }
  ]
})
export class DateInputFormControlComponent
  extends AbstractFormControlComponent<DateInputFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  faCheck: any = faCheck;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }
}
